import e from "@dialpad/dialtone-tokens/layered/themes/tokens-120-colors.css?inline";
//#region themes/120.js
var t = { brand: {
	css: e,
	name: "120"
} };
//#endregion
export { t as default };
